import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService, ConfigServerService, CustomHttp } from '../../../../../core';
import { NegocioOportunidadeUpdateCongelado } from '../congelado';
import { NegocioOportunidadeSearch } from '../negocio-oportunidade-search';

@Injectable({
    providedIn: 'root'
})
export class NegocioOportunidadeCongeladoHttpService {
    private pathApi: string;

    constructor(private authService: AuthService,
                configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/crm/negociooportunidade`;
    }

    /** Atualiza os dados do congelamento de um negócio */
    update(update: NegocioOportunidadeUpdateCongelado): Observable<NegocioOportunidadeSearch> {
        return this.customHttp.put<NegocioOportunidadeSearch>(`${this.pathApi}/${update.idNegocio}/congelado`, update);
    }

    /** descongela uma oportunidade de negócio */
    descongelar(idNegocio: number): Observable<NegocioOportunidadeSearch> {
        return this.customHttp.put<NegocioOportunidadeSearch>(`${this.pathApi}/${idNegocio}/descongelar`, null);
    }
}
